import React from "react";

function Context() {
  const styles = {
      item: {
         padding: 20,
      }
  };

  return (
    <div className="row">
      <div className="col s12">
        <div style={styles.item} className="col s6">
            <p><img src="/images/contexte/pluie.jpg" alt="pluie" width="16px" /> <strong>Météo : </strong><span>pluie / 11°C</span></p>
        </div>
        <div style={styles.item} className="col s6">
            <p><i className="material-icons context-icons">access_time</i> <strong>Date : </strong><span>mardi 11 juin 2019 à 16h</span></p>
        </div>
        <div style={styles.item} className="col s6">
            <p><i className="material-icons context-icons">location_on</i> <strong>Distance domicile : </strong><span>45 km</span></p>
        </div>
        <div style={styles.item} className="col s6">
          <p><i className="material-icons context-icons">flash_on</i> <strong>Panne récurrente : </strong><span>non</span></p>
        </div>
        <div style={styles.item} className="col s6">
          <p><i className="material-icons context-icons">child_friendly</i> <strong>enfants à charges : </strong><span>3 enfants</span></p>
        </div>
        <div style={styles.item} className="col s6">
            <p><i className="material-icons context-icons">date_range</i> <strong>Période vacances scolaires : </strong><span>non</span></p>
        </div>
        <div style={styles.item} className="col s6">
          <p><i className="material-icons context-icons">person</i> <strong>Situation familliale : </strong><span>Séparé</span></p>
        </div>

      </div>
    </div>
  )
}

  export default Context